//ERRORS
export const SET_ERRORS = "SET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
//CRASHES
export const SET_CRASHES = "SET_CRASHES";
export const CLEAR_CRASHES = "CLEAR_CRASHES";
//MESSAGE
export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
//AUTH
export const LOG_IN = "LOG_IN";
export const REGISTER = "REGISTER";
export const LOG_OUT = "LOG_OUT";
export const BOOTSTRAP_AUTH_OK = "BOOTSTRAP_AUTH_OK";
export const BOOTSTRAP_AUTH_FAIL = "BOOTSTRAP_AUTH_FAIL";


//WATCH-TOWER
export const GET_CONTACT_REQUESTS_WT = "GET_CONTACT_REQUESTS_WT";
export const GET_DEMO_CERTIFY_DOMAINS_WT = "GET_DEMO_CERTIFY_DOMAINS_WT";
export const GET_DEMO_CERTIFY_ANALYTICS_WT = "GET_DEMO_CERTIFY_ANALYTICS_WT";
export const GET_DEMO_CERTIFY_APPROVALS_WT = "GET_DEMO_CERTIFY_APPROVALS_WT";


//CONSUMER
export const GET_ALL_USERS_CON = "GET_ALL_USERS_CON";
export const GET_INTERNAL_USERS_CON = "GET_INTERNAL_USERS_CON";

//CONSUMER -> PAYMENTS
export const GET_CURRENCIES_CON_PAYMENTS = "GET_CURRENCIES_CON_PAYMENTS";
export const GET_USERS_CON_PAYMENTS = "GET_USERS_CON_PAYMENTS";

//CONSUMER -> VIRTUALCARDS
export const GET_CURRENCIES_CON_VCN = "GET_CURRENCIES_CON_VCN";

 
//BUSINESS
export const GET_SYSTEM_CONFIG_BIZ = "GET_SYSTEM_CONFIG_BIZ";
export const GET_UPLOADED_FILES_BIZ = "GET_UPLOADED_FILES_BIZ";
export const GET_CURRENCIES_BIZ = "GET_CURRENCIES_BIZ";
export const GET_ERROR_LOGS_BIZ = "GET_ERROR_LOGS_BIZ";
export const GET_ERROR_LOG_BIZ = "GET_ERROR_LOG_BIZ";
export const GET_ERROR_STATS_BIZ = "GET_ERROR_STATS_BIZ";

//BUSINESS -> NOTIFICATIONS
export const GET_EMAIL_TEMPLATES_BIZ_NOTIFICATIONS = "GET_EMAIL_TEMPLATES_BIZ_NOTIFICATIONS";
export const GET_EMAIL_TEMPLATE_BIZ_NOTIFICATIONS = "GET_EMAIL_TEMPLATE_BIZ_NOTIFICATIONS";
export const CLEAR_EMAIL_TEMPLATE_BIZ_NOTIFICATIONS = "CLEAR_EMAIL_TEMPLATE_BIZ_NOTIFICATIONS";

export const GET_EMAIL_ACTIVITIES_BIZ_NOTIFICATIONS = "GET_EMAIL_ACTIVITIES_BIZ_NOTIFICATIONS";

export const GET_SMS_TEMPLATES_BIZ_NOTIFICATIONS = "GET_SMS_TEMPLATES_BIZ_NOTIFICATIONS";
export const GET_SMS_TEMPLATE_BIZ_NOTIFICATIONS = "GET_SMS_TEMPLATE_BIZ_NOTIFICATIONS";

export const GET_SMS_ACTIVITIES_BIZ_NOTIFICATIONS = "GET_SMS_ACTIVITIES_BIZ_NOTIFICATIONS";

export const GET_OTP_RECORDS_BIZ_NOTIFICATIONS = "GET_OTP_RECORDS_BIZ_NOTIFICATIONS";
export const GET_NOTIFICATIONS_OVERVIEW_BIZ_NOTIFICATIONS = "GET_NOTIFICATIONS_OVERVIEW_BIZ_NOTIFICATIONS";

//BUSINESS -> NOTIFICATIONS
export const GET_PRODUCTS_BIZ_SUBSCRIPTIONS = "GET_PRODUCTS_BIZ_SUBSCRIPTIONS";
export const GET_DELIVERY_METHODS_BIZ_SUBSCRIPTIONS = "GET_DELIVERY_METHODS_BIZ_SUBSCRIPTIONS";
export const GET_INTEGRATIONS_BIZ_SUBSCRIPTIONS = "GET_INTEGRATIONS_BIZ_SUBSCRIPTIONS";
export const GET_SUBSCRIPTION_PLAN_BIZ_SUBSCRIPTIONS = "GET_SUBSCRIPTION_PLAN_BIZ_SUBSCRIPTIONS";
export const GET_SERVICES_BIZ_SUBSCRIPTIONS = "GET_SERVICES_BIZ_SUBSCRIPTIONS";
export const GET_PLAN_ADDONS_BIZ_SUBSCRIPTIONS = "GET_PLAN_ADDONS_BIZ_SUBSCRIPTIONS";
export const GET_COMPANY_PLAN_ADDONS_BIZ_SUBSCRIPTIONS = "GET_COMPANY_PLAN_ADDONS_BIZ_SUBSCRIPTIONS";
export const GET_SUBSCRIPTIONS_OVERVIEW_BIZ_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS_OVERVIEW_BIZ_SUBSCRIPTIONS";
export const GET_DISALLOWED_SERVICES_BIZ_SUBSCRIPTIONS = "GET_DISALLOWED_SERVICES_BIZ_SUBSCRIPTIONS";

//BUSINESS -> IDENTITY
export const GET_COMPANIES_BIZ_IDENTITY = "GET_COMPANIES_BIZ_IDENTITY";
export const GET_BRANCHES_BIZ_IDENTITY = "GET_BRANCHES_BIZ_IDENTITY";
export const GET_USERS_BIZ_IDENTITY = "GET_USERS_BIZ_IDENTITY";
export const GET_USER_CONSENTS_BIZ_IDENTITY = "GET_USER_CONSENTS_BIZ_IDENTITY";
export const GET_COMPANY_EMPLOYEES_BIZ_IDENTITY = "GET_COMPANY_EMPLOYEES_BIZ_IDENTITY";
export const GET_INTERNAL_USERS_BIZ_IDENTITY = "GET_INTERNAL_USERS_BIZ_IDENTITY";
export const GET_INTERNAL_USERS_MFA_BIZ_IDENTITY = "GET_INTERNAL_USERS_MFA_BIZ_IDENTITY";
export const GET_INTERNAL_USER_SESSIONS_BIZ_IDENTITY = "GET_INTERNAL_USER_SESSIONS_BIZ_IDENTITY";
export const GET_MFA_BACKUP_CODES_BIZ_IDENTITY = "GET_MFA_BACKUP_CODES_BIZ_IDENTITY";
export const GET_USER_SESSIONS_BIZ_IDENTITY = "GET_USER_SESSIONS_BIZ_IDENTITY";
export const GET_IDENTITY_OVERVIEW_BIZ_IDENTITY = "GET_IDENTITY_OVERVIEW_BIZ_IDENTITY";
export const GET_TENANTS_BIZ_IDENTITY = "GET_TENANTS_BIZ_IDENTITY";

//BUSINESS -> CORE
export const SELECT_TENANT_BIZ_CORE = "SELECT_TENANT_BIZ_CORE";
export const CLEAR_TENANT_BIZ_CORE = "CLEAR_TENANT_BIZ_CORE";

export const SELECT_COMPANY_BIZ_CORE = "SELECT_COMPANY_BIZ_CORE";
export const CLEAR_COMPANY_BIZ_CORE = "CLEAR_COMPANY_BIZ_CORE";

export const GET_CURRENCIES_BIZ_CORE = "GET_CURRENCIES_BIZ_CORE";
export const GET_INDUSTRIES_BIZ_CORE = "GET_INDUSTRIES_BIZ_CORE";
export const GET_ACCOUNT_TYPES_BIZ_CORE = "GET_ACCOUNT_TYPES_BIZ_CORE";
export const GET_CHART_OF_ACCOUNTS_BIZ_CORE = "GET_CHART_OF_ACCOUNTS_BIZ_CORE";

export const GET_TENANTS_BIZ_CORE = "GET_TENANTS_BIZ_CORE";
export const GET_COMPANIES_BIZ_CORE = "GET_COMPANIES_BIZ_CORE";
export const GET_COMPANIES_DROPDOWN_BIZ_CORE = "GET_COMPANIES_DROPDOWN_BIZ_CORE";
export const CLEAR_COMPANIES_DROPDOWN_BIZ_CORE = "CLEAR_COMPANIES_DROPDOWN_BIZ_CORE";

export const GET_BANK_ACCOUNT_TYPES_BIZ_CORE = "GET_BANK_ACCOUNT_TYPES_BIZ_CORE";
export const GET_BANKS_BIZ_CORE = "GET_BANKS_BIZ_CORE";
export const GET_HOLIDAYS_BIZ_CORE = "GET_HOLIDAYS_BIZ_CORE";
export const GET_COST_OBJECTS_BIZ_CORE = "GET_COST_OBJECTS_BIZ_CORE";
export const GET_TENANT_BANK_ACCOUNT_BIZ_CORE = "GET_TENANT_BANK_ACCOUNT_BIZ_CORE";

export const GET_PAYMENT_FREQUENCIES_BIZ_CORE = "GET_PAYMENT_FREQUENCIES_BIZ_CORE";
export const GET_SERVICE_FEES_BIZ_CORE = "GET_SERVICE_FEES_BIZ_CORE";
export const GET_INTERNATIONAL_SERVICE_FEES_BIZ_CORE = "GET_INTERNATIONAL_SERVICE_FEES_BIZ_CORE";
export const GET_INTERNATIONAL_USD_TO_USD_SERVICE_FEES_BIZ_CORE = "GET_INTERNATIONAL_USD_TO_USD_SERVICE_FEES_BIZ_CORE";

export const GET_PAYMENT_METHODS_BIZ_CORE = "GET_PAYMENT_METHODS_BIZ_CORE";
export const GET_CATEGORIES_BIZ_CORE = "GET_CATEGORIES_BIZ_CORE";

export const GET_COMPANY_CONFIG_BIZ_CORE = "GET_COMPANY_CONFIG_BIZ_CORE";
export const GET_EMPLOYEES_BIZ_CORE = "GET_EMPLOYEES_BIZ_CORE";
export const GET_COMPANY_BANK_ACCOUNT_BIZ_CORE = "GET_COMPANY_BANK_ACCOUNT_BIZ_CORE";

export const GET_COMPANY_DOMESTIC_BLNK_WALLET_BALANCE_BIZ_CORE = "GET_COMPANY_DOMESTIC_BLNK_WALLET_BALANCE_BIZ_CORE";
export const GET_COMPANY_DOMESTIC_BLNK_WALLET_TRANSACTIONS_BIZ_CORE = "GET_COMPANY_DOMESTIC_BLNK_WALLET_TRANSACTIONS_BIZ_CORE";
export const GET_COMPANY_INTERNATIONAL_BLNK_WALLET_BALANCE_BIZ_CORE = "GET_COMPANY_INTERNATIONAL_BLNK_WALLET_BALANCE_BIZ_CORE";
export const GET_COMPANY_INTERNATIONAL_BLNK_WALLET_TRANSACTIONS_BIZ_CORE = "GET_COMPANY_INTERNATIONAL_BLNK_WALLET_TRANSACTIONS_BIZ_CORE";

export const GET_DISCOUNTS_BIZ_CORE = "GET_DISCOUNTS_BIZ_CORE";
export const GET_BILLING_PLANS_BIZ_CORE = "GET_BILLING_PLANS_BIZ_CORE";
export const GET_BILLING_ADDONS_BIZ_CORE = "GET_BILLING_ADDONS_BIZ_CORE";
export const GET_BILLING_DOMESIC_WALLET_DEPOSITS_BIZ_CORE = "GET_BILLING_DOMESIC_WALLET_DEPOSITS_BIZ_CORE"; 
export const GET_BILLING_DOMESIC_WALLET_WITHDRAWALS_BIZ_CORE = "GET_BILLING_DOMESIC_WALLET_WITHDRAWALS_BIZ_CORE"; 
export const GET_BILLING_CBP_BIZ_CORE = "GET_BILLING_CBP_BIZ_CORE"; 
export const GET_BILLING_PAYS_BIZ_CORE = "GET_BILLING_PAYS_BIZ_CORE";
export const GET_BILLING_RECEIVES_BIZ_CORE = "GET_BILLING_RECEIVES_BIZ_CORE";
export const GET_BILLING_EXPENSES_BIZ_CORE = "GET_BILLING_EXPENSES_BIZ_CORE";

export const GET_SMART_LCS_BIZ_CORE = "GET_SMART_LCS_BIZ_CORE";
export const GET_SMART_LC_BIZ_CORE = "GET_SMART_LC_BIZ_CORE";
export const CLEAR_SMART_LC_BIZ_CORE = "CLEAR_SMART_LC_BIZ_CORE";

//BUSINESS -> CORE -> TRADE DEFENCE
export const GET_BROKERS_BIZ_CORE_TD = "GET_BROKERS_BIZ_CORE_TD";
export const GET_BROKERS_DROPDOWN_BIZ_CORE_TD = "GET_BROKERS_DROPDOWN_BIZ_CORE_TD";
export const CLEAR_BROKERS_DROPDOWN_BIZ_CORE_TD = "CLEAR_BROKERS_DROPDOWN_BIZ_CORE_TD";
export const GET_COMPLIANCE_VECTORS_BIZ_CORE_TD = "GET_COMPLIANCE_VECTORS_BIZ_CORE_TD";
export const GET_COMPLIANCE_VECTORS_DROPDOWN_BIZ_CORE_TD = "GET_COMPLIANCE_VECTORS_DROPDOWN_BIZ_CORE_TD";
export const CLEAR_COMPLIANCE_VECTORS_DROPDOWN_BIZ_CORE_TD = "CLEAR_COMPLIANCE_VECTORS_DROPDOWN_BIZ_CORE_TD";
export const GET_COMPANY_VECTOR_PREFS_BIZ_CORE_TD = "GET_COMPANY_VECTOR_PREFS_BIZ_CORE_TD";
export const GET_COMPANY_VECTOR_PREFS_SUMMARY_BIZ_CORE_TD = "GET_COMPANY_VECTOR_PREFS_SUMMARY_BIZ_CORE_TD";
export const GET_COMPANY_VECTOR_PREFS_BY_COMPANY_BIZ_CORE_TD = "GET_COMPANY_VECTOR_PREFS_BY_COMPANY_BIZ_CORE_TD";
export const CLEAR_COMPANY_VECTOR_PREFS_DETAIL_BIZ_CORE_TD = "CLEAR_COMPANY_VECTOR_PREFS_DETAIL_BIZ_CORE_TD";
export const GET_SYSTEM_VALIDATION_RULES_BIZ_CORE_TD = "GET_SYSTEM_VALIDATION_RULES_BIZ_CORE_TD";
export const GET_USITC_HTS_CODES_BIZ_CORE_TD = "GET_USITC_HTS_CODES_BIZ_CORE_TD";
export const GET_USITC_HTS_CODES_DROPDOWN_BIZ_CORE_TD = "GET_USITC_HTS_CODES_DROPDOWN_BIZ_CORE_TD";
export const CLEAR_USITC_HTS_CODES_DROPDOWN_BIZ_CORE_TD = "CLEAR_USITC_HTS_CODES_DROPDOWN_BIZ_CORE_TD";
export const GET_USTR_EXCLUSIONS_BIZ_CORE_TD = "GET_USTR_EXCLUSIONS_BIZ_CORE_TD";
export const GET_USITC_REVISIONS_BIZ_CORE_TD = "GET_USITC_REVISIONS_BIZ_CORE_TD";
export const GET_USITC_REVISIONS_DROPDOWN_BIZ_CORE_TD = "GET_USITC_REVISIONS_DROPDOWN_BIZ_CORE_TD";
export const CLEAR_USITC_REVISIONS_DROPDOWN_BIZ_CORE_TD = "CLEAR_USITC_REVISIONS_DROPDOWN_BIZ_CORE_TD";
export const GET_USITC_SPI_RATES_BIZ_CORE_TD = "GET_USITC_SPI_RATES_BIZ_CORE_TD";
export const GET_USITC_CHAPTER_99_MAPPINGS_BIZ_CORE_TD = "GET_USITC_CHAPTER_99_MAPPINGS_BIZ_CORE_TD";
export const GET_ASSEMBLY_SESSIONS_BIZ_CORE_TD = "GET_ASSEMBLY_SESSIONS_BIZ_CORE_TD";
export const GET_ASSEMBLY_DOCUMENTS_BIZ_CORE_TD = "GET_ASSEMBLY_DOCUMENTS_BIZ_CORE_TD";
export const GET_STAGING_ENTRIES_BIZ_CORE_TD = "GET_STAGING_ENTRIES_BIZ_CORE_TD";
export const GET_STAGING_DOCUMENTS_BIZ_CORE_TD = "GET_STAGING_DOCUMENTS_BIZ_CORE_TD";
export const GET_CUSTOMS_ENTRIES_BIZ_CORE_TD = "GET_CUSTOMS_ENTRIES_BIZ_CORE_TD";
export const GET_ENTRY_DOCUMENTS_BIZ_CORE_TD = "GET_ENTRY_DOCUMENTS_BIZ_CORE_TD";
export const GET_PIVOT_MASTERS_BIZ_CORE_TD = "GET_PIVOT_MASTERS_BIZ_CORE_TD";
export const GET_PIVOT_ROWS_BIZ_CORE_TD = "GET_PIVOT_ROWS_BIZ_CORE_TD";
export const GET_CI_MASTERS_BIZ_CORE_TD = "GET_CI_MASTERS_BIZ_CORE_TD";
export const GET_CI_LINES_BIZ_CORE_TD = "GET_CI_LINES_BIZ_CORE_TD";
export const GET_FORM_7501_HEADERS_BIZ_CORE_TD = "GET_FORM_7501_HEADERS_BIZ_CORE_TD";
export const GET_FORM_7501_LINES_BIZ_CORE_TD = "GET_FORM_7501_LINES_BIZ_CORE_TD";
export const GET_BOL_HEADERS_BIZ_CORE_TD = "GET_BOL_HEADERS_BIZ_CORE_TD";
export const GET_SC_NODES_BIZ_CORE_TD = "GET_SC_NODES_BIZ_CORE_TD";
export const GET_SC_NODE_CONTENT_BIZ_CORE_TD = "GET_SC_NODE_CONTENT_BIZ_CORE_TD";
export const GET_SC_NODE_REVISION_STATUS_BIZ_CORE_TD = "GET_SC_NODE_REVISION_STATUS_BIZ_CORE_TD";
export const GET_SC_SEGMENTATION_RUNS_BIZ_CORE_TD = "GET_SC_SEGMENTATION_RUNS_BIZ_CORE_TD";
export const GET_SC_PAGE_FURNITURE_LOG_BIZ_CORE_TD = "GET_SC_PAGE_FURNITURE_LOG_BIZ_CORE_TD";
export const GET_SC_RULE_FRAMEWORKS_BIZ_CORE_TD = "GET_SC_RULE_FRAMEWORKS_BIZ_CORE_TD";
export const GET_SC_RULE_FRAMEWORK_MEMBERS_BIZ_CORE_TD = "GET_SC_RULE_FRAMEWORK_MEMBERS_BIZ_CORE_TD";
export const GET_SC_PARSE_REVIEWS_BIZ_CORE_TD = "GET_SC_PARSE_REVIEWS_BIZ_CORE_TD";
export const GET_SC_PSEUDOCODE_BIZ_CORE_TD = "GET_SC_PSEUDOCODE_BIZ_CORE_TD";
export const GET_SC_CH99_RULES_BIZ_CORE_TD = "GET_SC_CH99_RULES_BIZ_CORE_TD";
export const GET_SC_RULE_INTERACTIONS_BIZ_CORE_TD = "GET_SC_RULE_INTERACTIONS_BIZ_CORE_TD";
export const GET_SC_HTS_CH99_MAPPINGS_BIZ_CORE_TD = "GET_SC_HTS_CH99_MAPPINGS_BIZ_CORE_TD";

//BUSINESS -> CORE -> CC
export const GET_COUNTRIES_BIZ_CORE_CC = "GET_COUNTRIES_BIZ_CORE_CC";
export const GET_CURRENCIES_BIZ_CORE_CC = "GET_CURRENCIES_BIZ_CORE_CC";

export const GET_PAYMENT_COUNTRIES_BIZ_CORE_CC = "GET_PAYMENT_COUNTRIES_BIZ_CORE_CC";
export const GET_PAYMENT_CURRENCIES_BIZ_CORE_CC = "GET_PAYMENT_CURRENCIES_BIZ_CORE_CC";
export const GET_PAYMNET_PUPOSES_BIZ_CORE_CC = "GET_PAYMNET_PUPOSES_BIZ_CORE_CC";
export const GET_PAYMENT_COUNTRY_CURRENCY_XREF_BIZ_CORE_CC = "GET_PAYMENT_COUNTRY_CURRENCY_XREF_BIZ_CORE_CC";
export const GET_PAYMENT_SERVICES_BIZ_CORE_CC = "GET_PAYMENT_SERVICES_BIZ_CORE_CC";

export const GET_COLLECTION_COUNTRIES_BIZ_CORE_CC = "GET_COLLECTION_COUNTRIES_BIZ_CORE_CC";
export const GET_COLLECTION_CURRENCIES_BIZ_CORE_CC = "GET_COLLECTION_CURRENCIES_BIZ_CORE_CC";
export const GET_COLLECTION_COUNTRY_CURRENCY_BIZ_CORE_CC = "GET_COLLECTION_COUNTRY_CURRENCY_BIZ_CORE_CC";
export const GET_COLLECTION_SERVICES_BIZ_CORE_CC = "GET_COLLECTION_SERVICES_BIZ_CORE_CC";

//BUSINESS -> FUSION
export const GET_ACTIVITIES_BIZ_FUSION = "GET_ACTIVITIES_BIZ_FUSION";

//BUSINESS -> FUSION -> ORUM
export const GET_WEBHOOKS_BIZ_FUSION_ORUM = "GET_WEBHOOKS_BIZ_FUSION_ORUM";

//BUSINESS -> FUSION -> WYZIA
export const GET_CAMPAIGNS_BIZ_FUSION_WYZIA = "GET_CAMPAIGNS_BIZ_FUSION_WYZIA";

//BUSINESS -> FUSION -> CC
export const SELECT_ACCOUNT_BIZ_FUSION_CC = "SELECT_ACCOUNT_BIZ_FUSION_CC";
export const CLEAR_ACCOUNT_BIZ_FUSION_CC = "CLEAR_ACCOUNT_BIZ_FUSION_CC";

export const GET_ACCOUNTS_BIZ_FUSION_CC = "GET_ACCOUNTS_BIZ_FUSION_CC";
export const GET_CONTACTS_BIZ_FUSION_CC = "GET_CONTACTS_BIZ_FUSION_CC";
export const GET_BENEFICIARIES_BIZ_FUSION_CC = "GET_BENEFICIARIES_BIZ_FUSION_CC";
export const GET_CONVERSIONS_BIZ_FUSION_CC = "GET_CONVERSIONS_BIZ_FUSION_CC";
export const GET_BASIC_RATES_BIZ_FUSION_CC = "GET_BASIC_RATES_BIZ_FUSION_CC";
export const GET_DETAILED_RATES_BIZ_FUSION_CC = "GET_DETAILED_RATES_BIZ_FUSION_CC";
export const GET_PAYMENTS_BIZ_FUSION_CC = "GET_PAYMENTS_BIZ_FUSION_CC";
export const GET_TRANSFERS_BIZ_FUSION_CC = "GET_TRANSFERS_BIZ_FUSION_CC";

//BUSINESS -> FUSION -> ALTCARD
export const GET_PARTIES_BIZ_FUSION_ALT = "GET_PARTIES_BIZ_FUSION_ALT";
export const GET_PARTIES_BANK_ACCOUNTS_BIZ_FUSION_ALT = "GET_PARTIES_BANK_ACCOUNTS_BIZ_FUSION_ALT";


//BUSINESS -> WEBHOOK
export const GET_ACTIVITIES_BIZ_WEBHOOK = "GET_ACTIVITIES_BIZ_WEBHOOK";
export const GET_WEBHOOK_LOGS_BIZ_WEBHOOK = "GET_WEBHOOK_LOGS_BIZ_WEBHOOK";


//BUSINESS -> ACCOUNTING TPI -> QUICKBOOKS DESKTOP
export const GET_CONNECTIONS_BIZ_ACCTPI_QBD = "GET_CONNECTIONS_BIZ_ACCTPI_QBD";
export const GET_OPERATIONS_BIZ_ACCTPI_QBD = "GET_OPERATIONS_BIZ_ACCTPI_QBD";
export const GET_TICKETS_BIZ_ACCTPI_QBD = "GET_TICKETS_BIZ_ACCTPI_QBD";

export const GET_CLASSES_MAPPING_BIZ_ACCTPI_QBD = "GET_CLASSES_MAPPING_BIZ_ACCTPI_QBD";
export const GET_ACCOUNTS_MAPPING_BIZ_ACCTPI_QBD = "GET_ACCOUNTS_MAPPING_BIZ_ACCTPI_QBD";
export const GET_SALES_MAPPING_TAXES_BIZ_ACCTPI_QBD = "GET_SALES_MAPPING_TAXES_BIZ_ACCTPI_QBD";
export const GET_ITEMS_MAPPING_BIZ_ACCTPI_QBD = "GET_ITEMS_MAPPING_BIZ_ACCTPI_QBD";
export const GET_VENDORS_MAPPING_BIZ_ACCTPI_QBD = "GET_VENDORS_MAPPING_BIZ_ACCTPI_QBD";
export const GET_CUSTOMERS_MAPPING_BIZ_ACCTPI_QBD = "GET_CUSTOMERS_MAPPING_BIZ_ACCTPI_QBD";
export const GET_BILLS_MAPPING_BIZ_ACCTPI_QBD = "GET_BILLS_MAPPING_BIZ_ACCTPI_QBD";
export const GET_BILL_PAYMENTS_MAPPING_BIZ_ACCTPI_QBD = "GET_BILL_PAYMENTS_MAPPING_BIZ_ACCTPI_QBD";
export const GET_INVOICES_MAPPING_BIZ_ACCTPI_QBD = "GET_INVOICES_MAPPING_BIZ_ACCTPI_QBD";
export const GET_INVOICE_PAYMENTS_MAPPING_BIZ_ACCTPI_QBD = "GET_INVOICE_PAYMENTS_MAPPING_BIZ_ACCTPI_QBD";
export const GET_JOURNAL_ENTRIES_MAPPING_BIZ_ACCTPI_QBD = "GET_JOURNAL_ENTRIES_MAPPING_BIZ_ACCTPI_QBD";
export const GET_CHECKS_MAPPING_BIZ_ACCTPI_QBD = "GET_CHECKS_MAPPING_BIZ_ACCTPI_QBD";


//CERTIFICATION
export const GET_AUTHORITIES_CERT = "GET_AUTHORITIES_CERT";
export const GET_AUTHORITIES_DROPDOWN_CERT = "GET_AUTHORITIES_DROPDOWN_CERT";
export const GET_DBE_CERT = "GET_DBE_CERT";
export const GET_DOT_LICENSE_BATCHES_CERT = "GET_DOT_LICENSE_BATCHES_CERT";
export const GET_DOT_LICENSE_BATCH_DETAIL_CERT = "GET_DOT_LICENSE_BATCH_DETAIL_CERT";
export const GET_WORKFLOW_TEMPLATES_CERT = "GET_WORKFLOW_TEMPLATES_CERT";
export const GET_WORKFLOW_TEMPLATE_AUTHORITIES_CERT = "GET_WORKFLOW_TEMPLATE_AUTHORITIES_CERT";
export const CLEAR_WORKFLOW_TEMPLATE_AUTHORITIES_CERT = "CLEAR_WORKFLOW_TEMPLATE_AUTHORITIES_CERT";
export const GET_WORKFLOW_TEMPLATE_GROUPS_CERT = "GET_WORKFLOW_TEMPLATE_GROUPS_CERT";
export const GET_WORKFLOW_TEMPLATE_GROUP_AUTHORITIES_CERT = "GET_WORKFLOW_TEMPLATE_GROUP_AUTHORITIES_CERT";
export const CLEAR_WORKFLOW_TEMPLATE_GROUP_AUTHORITIES_CERT = "CLEAR_WORKFLOW_TEMPLATE_GROUP_AUTHORITIES_CERT";


//SUPPORT
export const GET_ISSUES_SPT = "GET_ISSUES_SPT";


//SUPPORT -> CONFIG
export const GET_CATEGORIES_SPT_CONFIG = "GET_CATEGORIES_SPT_CONFIG";
export const GET_STAGES_SPT_CONFIG = "GET_STAGES_SPT_CONFIG";

//SDK

// BUSINESS - core :: vendors & customers
export const GET_VENDORS_BIZ_CORE_PAY = "GET_VENDORS_BIZ_CORE_PAY";
export const GET_VENDORS_ANALYTICS_BIZ_CORE_PAY = "GET_VENDORS_ANALYTICS_BIZ_CORE_PAY";
export const GET_CUSTOMERS_BIZ_CORE_RCV = "GET_CUSTOMERS_BIZ_CORE_RCV";
export const GET_CUSTOMERS_ANALYTICS_BIZ_CORE_RCV = "GET_CUSTOMERS_ANALYTICS_BIZ_CORE_RCV";
